<template>
  <div>
    <ListingLayout
      :sub-screen="1"
      :is-loading="isLoading"
      :meta="meta"
      :headers="_headers"
      :items="list"
      :bread-crumbs="false"
      no-filters
      show-date
      :date-validation="false"
      vertical-scroll
      :data-table-key="1"
      @filterOption="onFiltersChange"
    >
      <!-- :date-custom-options="false" -->
      <template v-slot:state_of_charge="{ item }">
        <div>
          <span v-if="item.state_of_charge == 'N/A'">
            {{ item.state_of_charge }}
          </span>
          <span v-else> {{ item.state_of_charge }} % </span>
        </div>
      </template>
      <template v-slot:state_of_health="{ item }">
        <div>
          <span v-if="item.state_of_health == 'N/A'">
            {{ item.state_of_health }}
          </span>
          <span v-else> {{ item.state_of_health }} % </span>
        </div>
      </template>
      <template v-slot:start_soc="{ item }">
        <div>
          <span v-if="item.start_soc == 'N/A'">
            {{ item.start_soc }}
          </span>
          <span v-else> {{ item.start_soc }} % </span>
        </div>
      </template>
      <template v-slot:end_soc="{ item }">
        <div>
          <span v-if="item.end_soc == 'N/A'">
            {{ item.end_soc }}
          </span>
          <span v-else> {{ item.end_soc }} % </span>
        </div>
      </template>
      <template v-slot:duration="{ item }">
        <div>{{ item.duration }}</div>
      </template>
      <template v-slot:charge_gain="{ item }">
        <div>
          <span v-if="item.charge_gain == 'N/A'">
            {{ item.charge_gain }}
          </span>
          <span v-else> {{ item.charge_gain }} % </span>
        </div>
      </template>
      <template v-slot:energy_consumption="{ item }">
        <div>{{ item.energy_consumption }}</div>
      </template>
      <template v-slot:Total_Voltage="{ item }">
        <div>
          <span v-if="item.Total_Voltage == null"> N/A </span>
          <span v-else> {{ item.Total_Voltage }} % </span>
        </div>
      </template>
      <template v-slot:Cell1_Voltage="{ item }">
        <div>
          <span> {{ item.Cell1_Voltage ? item.Cell1_Voltage : "N/A" }} </span>
        </div>
      </template>
      <template v-slot:Cell2_Voltage="{ item }">
        <div>
          <span> {{ item.Cell2_Voltage ? item.Cell2_Voltage : "N/A" }} </span>
        </div>
      </template>
      <template v-slot:Cell3_Voltage="{ item }">
        <div>
          <span> {{ item.Cell3_Voltage ? item.Cell3_Voltage : "N/A" }} </span>
        </div>
      </template>
      <template v-slot:Cell4_Voltage="{ item }">
        <div>
          <span> {{ item.Cell4_Voltage ? item.Cell4_Voltage : "N/A" }} </span>
        </div>
      </template>
      <template v-slot:Cell5_Voltage="{ item }">
        <div>
          <span> {{ item.Cell5_Voltage ? item.Cell5_Voltage : "N/A" }} </span>
        </div>
      </template>
      <template v-slot:Cell6_Voltage="{ item }">
        <div>
          <span> {{ item.Cell6_Voltage ? item.Cell6_Voltage : "N/A" }} </span>
        </div>
      </template>
      <template v-slot:Cell7_Voltage="{ item }">
        <div>
          <span> {{ item.Cell7_Voltage ? item.Cell7_Voltage : "N/A" }} </span>
        </div>
      </template>
      <template v-slot:Cell8_Voltage="{ item }">
        <div>
          <span> {{ item.Cell8_Voltage ? item.Cell8_Voltage : "N/A" }} </span>
        </div>
      </template>
      <template v-slot:Cell9_Voltage="{ item }">
        <div>
          <span> {{ item.Cell9_Voltage ? item.Cell9_Voltage : "N/A" }} </span>
        </div>
      </template>
      <template v-slot:Cell10_Voltage="{ item }">
        <div>
          <span> {{ item.Cell10_Voltage ? item.Cell10_Voltage : "N/A" }} </span>
        </div>
      </template>
      <template v-slot:Cell11_Voltage="{ item }">
        <div>
          <span> {{ item.Cell11_Voltage ? item.Cell11_Voltage : "N/A" }} </span>
        </div>
      </template>
      <template v-slot:Cell12_Voltage="{ item }">
        <div>
          <span> {{ item.Cell12_Voltage ? item.Cell12_Voltage : "N/A" }} </span>
        </div>
      </template>
      <template v-slot:Cell13_Voltage="{ item }">
        <div>
          <span> {{ item.Cell13_Voltage ? item.Cell13_Voltage : "N/A" }} </span>
        </div>
      </template>
      <template v-slot:Cell14_Voltage="{ item }">
        <div>
          <span> {{ item.Cell14_Voltage ? item.Cell14_Voltage : "N/A" }} </span>
        </div>
      </template>
      <template v-slot:Cell15_Voltage="{ item }">
        <div>
          <span> {{ item.Cell15_Voltage ? item.Cell15_Voltage : "N/A" }} </span>
        </div>
      </template>
      <template v-slot:Cell16_Voltage="{ item }">
        <div>
          <span> {{ item.Cell16_Voltage ? item.Cell16_Voltage : "N/A" }} </span>
        </div>
      </template>
      <template v-slot:Cell17_Voltage="{ item }">
        <div>
          <span> {{ item.Cell17_Voltage ? item.Cell17_Voltage : "N/A" }} </span>
        </div>
      </template>
      <template v-slot:Cell18_Voltage="{ item }">
        <div>
          <span> {{ item.Cell18_Voltage ? item.Cell18_Voltage : "N/A" }} </span>
        </div>
      </template>
      <template v-slot:Cell19_Voltage="{ item }">
        <div>
          <span> {{ item.Cell19_Voltage ? item.Cell19_Voltage : "N/A" }} </span>
        </div>
      </template>
      <template v-slot:Cell20_Voltage="{ item }">
        <div>
          <span> {{ item.Cell20_Voltage ? item.Cell20_Voltage : "N/A" }} </span>
        </div>
      </template>

      <!-- add Filters -->
      <!-- <template #addFilters>
        <v-card v-if="authUser.isAdmin">
          
        </v-card>
      </template> -->
      <!-- add Filters -->

      <!-- Action Modals -->
      <template #actionModals>
        <refresh-button
          :is-loading="isLoading"
          @reload="fetchData"
        />
      </template>
      <!-- Action Modals -->
    </ListingLayout>
  </div>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
import { mapGetters } from "vuex";
// import { debounce } from "lodash";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    refreshButton: () => import("@/components/base/RefreshButton.vue"),
  },
  mixins: [ListingLayoutMixins],

  data() {
    return {
      filters: {},
      subFilters: {},
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "batteryDiagnostics/getIsLoading",
      meta: "batteryDiagnostics/getMeta",
      list: "batteryDiagnostics/getBatteryDiagnostics",
      //
      headersList: "batteryDiagnostics/getHeaders",
      //
      batteryInfo: "batterries/batterriesItem",
    }),
    vehicle_type() {
      return this.$route.query.type;
    },
    _headers() {
      var headerArr = [];
      this.headersList.forEach((header) => {
        headerArr.push({
          text: this.$t(header.key),
          // text: header.key,
          align: "center",
          sortable: false,
          value: header.key,
          width: "10%",
        });
      });

      // return this.vehicle_type == "three_wheeler" ? headerArr : this.headers;
      return headerArr;
    },
  },
  watch: {
    options() {
      this.fetchData();
    },
  },
  beforeDestroy() {
    this.$store.commit("batteryDiagnostics/SET_BATTERY_DIAGNOSTICS", []);
  },
  async mounted() {
    const params = {
      // tenant_id:
      //   this.authUser.isAdmin || this.authUser.user_nature == "fleet"
      //     ? this.$route.query.tenant_id
      //     : this.authUser.tenant_id,
      // // tenant_id: this.batteryInfo.tenant_id,
      tenant_id: this.batteryInfo.tenant_id,
      vehicle_id: this.$route.query.vehicle_id,
    };

    await this.$store.dispatch("batteryDiagnostics/headers", params);
  },
  methods: {
    async fetchData() {
      const imei = this.$route.params.imei;
      this.options.bmsId = this.$route.query.bmsId;
      this.options.imei = imei;
      if (this.vehicle_type == "three_wheeler") {
        if (
          this.vehicle_type === "three_wheeler" &&
          this.$route.query.battery_slot_type === "fixed"
        ) {
          await this.$store
            .dispatch("batteryDiagnostics/list", this.options)
            .then(() => {});
        } else {
          await this.$store
            .dispatch("batteryDiagnostics/batteryTelematicList", this.options)
            .then(() => {});
        }
      } else {
        await this.$store
          .dispatch("batteryDiagnostics/list", this.options)
          .then(() => {});
      }
    },
  },
};
</script>
